import { render } from "./HelpButton.vue?vue&type=template&id=625fc53a&scoped=true"
import script from "./HelpButton.vue?vue&type=script&lang=js"
export * from "./HelpButton.vue?vue&type=script&lang=js"

import "./HelpButton.vue?vue&type=style&index=0&id=625fc53a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625fc53a"]])

export default __exports__